module.exports = "pegasus/assets/tech/conference/100.png";